/**
 * Persist signup profile fields into auto-starter onboarding state
 * so onboarding can start at goals without re-asking name/email.
 */

import axios from 'axios';
import { getApiBase } from './creditImportStatus';

const SKIPPED_AFTER_SIGNUP = ['social_proof', 'package_offer', 'pre_credentials_video'];

export function splitFullName(fullName = '') {
  const parts = String(fullName).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
  }
  return { firstName: parts[0] || '', lastName: '' };
}

export async function saveSignupProfileToOnboarding(token, { name, email, phone }) {
  if (!token) return;

  const API = getApiBase();
  const headers = { Authorization: `Bearer ${token}` };
  const { firstName, lastName } = splitFullName(name);

  await axios.post(
    `${API}/auto-starter/onboarding/step`,
    {
      step: 'welcome_terms',
      data: { terms_accepted: true },
      mark_completed: true,
    },
    { headers }
  );

  await axios.post(
    `${API}/auto-starter/onboarding/step`,
    {
      step: 'basic_info',
      data: {
        first_name: firstName,
        last_name: lastName,
        email,
        phone,
        basic_info_completed: true,
      },
      mark_completed: true,
    },
    { headers }
  );

  for (const step of SKIPPED_AFTER_SIGNUP) {
    try {
      await axios.post(
        `${API}/auto-starter/onboarding/step`,
        { step, data: {}, mark_skipped: true },
        { headers }
      );
    } catch (error) {
      console.warn(`[signup] could not skip onboarding step ${step}`, error);
    }
  }
}
